/*
 * @author Andrey Patyuchenko
 * @email  apatyuchenko@atlassian.com
 * @email  andrey.patyuchenko@gmail.com
 * @date   4/4/22
 */

import React from "react";
import {FormControl, FormHelperText, InputLabel, MenuItem, Select, Stack} from "@mui/material";

export interface CapacityModifierControlProps {
	label?: string
	hint?: string
	disabled?: boolean
	value: number
	setValue: (number: number) => void
}

const presets = [.05, .1, .15, .2, .25, .3, .33, .35, .4, .45, .5, .55, .6, .65, .67, .7, .75, .8, .85, .9, .95];

export default function CapacityModifierControl(props: CapacityModifierControlProps) {

	const [preset, setPreset] = React.useState(() => {
		return [0, ...presets, 1].includes(props.value) ? String(props.value) : "custom";
	});

	React.useEffect(() => {
		setPreset(String(props.value));
	}, [props.value])

	return (
		<Stack>
			<FormControl sx={{ width: 160 }} variant={"standard"} disabled={props.disabled}>
				<InputLabel>{props.label ?? "Capacity Modifier"}</InputLabel>
				<Select
					value={preset}
					onChange={(event) => {
						const value = event.target.value as string;
						setPreset(value);
						if (value !== "custom") {
							props.setValue(Number(value));
						}
					}}
				>
					<MenuItem key={"0"} value={"0"}>0% (Unavailable)</MenuItem>
					{presets.map(p => <MenuItem key={p} value={String(p)}>{Math.round(p*100)}%</MenuItem>)}
					<MenuItem key={"1"} value={"1"}>100% (Available)</MenuItem>
				</Select>
			</FormControl>
			{props.hint && <FormHelperText>{props.hint}</FormHelperText>}
		</Stack>
	);

}